import { handleActions } from "../../utils/redux-utils";

export const initialState = {
  isRakezLoading: false,
  rakezFetchCompleted: false,
  rakezData: {},
  rawResponse: null,
  rakezError: {}
};

export default handleActions(
  {
    SET_RAKEZ_DATA_LOADING: (state, { payload: { isLoading } }) => ({
      ...state,
      isRakezLoading: isLoading
    }),
    SET_RAKEZ_FETCH_COMPLETED: (state, { payload: { isCompleted } }) => ({
      ...state,
      rakezFetchCompleted: isCompleted
    }),
    SET_RAKEZ_DATA: (state, { payload: { data, rawResponse } }) => ({
      ...state,
      rakezData: data,
      rawResponse: rawResponse || state.rawResponse
    }),
    SET_RAKEZ_ERROR: (state, { payload: { key, error, id } }) => ({
      ...state,
      isRakezLoading: false,
      rakezData: {
        ...state.rakezData,
        [key]: ""
      },
      rakezError: {
        ...state.rakezError,
        [id]: { key, error }
      }
    }),
    RESET_RAKEZ_STATES: () => initialState
  },
  initialState
);
